import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

export interface WeatherResponse {
    weather: [{ id: number; description: string }];
    main: { temp: number };
    // name: string;
}
@Injectable({
    providedIn: 'root',
})
export class WeatherHttpService {
    private baseurl: string;
    private weatherCache: Map<string, { timestamp: number; response: WeatherResponse }> = new Map();

    constructor(private http: HttpClient) {
        this.baseurl = 'https://api.openweathermap.org';
    }

    // url = `data/2.5/weather?lat=${Latitude}&lon=${Longitude}&units=metric&lang=de&APPID=84ff67896b8e733e9e744f1cdddc9386`;
    public getWeather(city: string, countryCode = 'de'): Observable<WeatherResponse> {
        const url = `data/2.5/weather?q=${city},${countryCode}&units=metric&lang=de&APPID=84ff67896b8e733e9e744f1cdddc9386`;
        const timestamp = Date.now();
        this.weatherCache.forEach((value, key) => {
            // remove older then 1h
            if (timestamp - value.timestamp > 1000 * 60 * 1) {
                this.weatherCache.delete(key);
            }
        });
        const cached = this.weatherCache.get(city);
        if (cached) {
            return of(cached.response);
        }

        return this.http.jsonp(`${this.baseurl}/${url}`, 'callback').pipe(
            map((res) => res as WeatherResponse),
            tap((res) => {
                if (res) {
                    this.weatherCache.set(city, { timestamp, response: res });
                }
            }),
            catchError((err) => {
                // const error = Error(`Weather for ${city} failed`, { cause: err }); ES2022 +
                console.error(err);
                Sentry.captureException(Error('getWeather failed'), {
                    level: 'warning',
                    extra: {
                        city: city,
                        cause: err,
                    },
                });
                return of(null);
            }),
        );
    }
}
